import React from "react";
import EngineDrillDownPage from "../../../../components/pages/_new/super/engines/EngineDrillDownPage";

const PingoraDetailPage = () => <EngineDrillDownPage engineType="PINGORA" />;

export default PingoraDetailPage;
